import { StatusIndicator } from '@/components/ui/status-indicator.tsx'
import { ActivityState } from '@/modules/activity-state/types.ts'

const colorClassNames: Record<ActivityState, string> = {
  ONLINE: 'bg-green-500',
  IDLE: 'bg-yellow-500',
  OFFLINE: 'bg-red-500',
}

const statusMessages: Record<ActivityState, string> = {
  ONLINE: 'This user is currently active',
  IDLE: 'This user is currently online but inactive',
  OFFLINE: 'This user is currently offline',
}

export const ActivityStateIndicator = ({ state }: { state: ActivityState }) => {
  const colorClassName = colorClassNames[state]
  const statusMessage = statusMessages[state]

  return (
    <StatusIndicator
      colorClassName={colorClassName}
      tooltipContent={statusMessage}
    />
  )
}
